<template>
  <div class="container">
    <div class="nav">
      <div :class="[tab?'nav_tab_chose':'nav_tab']" @click="chose(tab,0)">课程使用</div>
      <div :class="[tab?'nav_tab':'nav_tab_chose']" @click="chose(tab,1)">干货使用</div>
    </div>
    <div class="content">
      <div class="item"  v-for="(item,index) in getCoupon" :key="index">
        <div class="item_content">
            <div class="item_left">
              <div class="item_left_money" v-if="item.use_type=='1'">
                <span class="font">{{item.reduce}}</span>
                <span class="font1">元</span>
              </div>
              <div class="font2" v-if="item.use_type=='1'">满{{item.quota}}元可用</div>
              <div class="item_left_money" v-if="item.use_type=='2'">
                <span class="font">{{item.discount}}</span>
                <span class="font1">折</span>
              </div>
              
            </div>
            <div class="item_center">
              <div class="item_left_money">
                <span class="font3">{{item.name}}</span>
              </div>
              <div class="font2">有效期至：{{item.end_date}}</div>
            </div>
            <div class="item_right">
              <div class="btn" @click="toUse(item.type)">立即使用</div>
            </div>
        </div>
        <div class="item_bottom">
          <div class="font2" v-if="item.type=='1'">全场通用</div>
          <div class="font2" v-if="item.type=='3'">干货可用</div>
          <div class="font2" v-if="item.type=='2'">课程可用</div>
          <!-- <img class="right_icon" :src='rightImg' alt=""> -->
        </div>
      </div>
      
      
     
      
      
    </div>
    <div class="empty" v-if="getCoupon.length=='0'">
      <img class="pic" :src="emptyImg">
      <div class="pro">查询无记录</div>
    </div>
  </div>
</template>
<style scoped>
.empty{
  margin-top: 70px;
  width:100%;
  height: 250px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgb(255,255,255);
  padding-top:42px;
  flex-direction: column;
}
.pic{
  width:120px;
  height:120px;
}
.pro{
  color: rgb(34,34,34);
  font-size: 14px;
  margin-top: 20px;
}
.font2{
  color: 12px;
  color: grey;
}

.container{
  overflow-y: scroll;
  /* font-family:Helvetica, Tahoma, Arial, "PingFang SC", "Hiragino Sans GB", "Heiti SC", "Microsoft YaHei", "WenQuanYi Micro Hei"; */
  color: rgb(34,34,34);
  /* background-color: #fff; */
}
.nav{
  height: 60px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color:#fff ;
}
.nav_tab{
  color: rgb(125,125,125);
  font-size: 16px;
  font-weight: 600;
}
.nav_tab_chose{
  color: #B3212D;
  font-size: 16px;
  font-weight: 600;
  padding-bottom: 6px;
  border-bottom: 2px solid #B3212D;
}
.content{
  width: calc(100% - 30px);
  margin-left: 15px;
  box-sizing: border-box;
  margin-top: 80px;
}
.item{
  width: 100%;
  border:1px solid #e7e7e7;
  border-radius: 6px;
  margin-bottom: 15px;
  background-color: #fff;
  box-shadow: 0 2px 3px 0 rgba(0,0,0,0.2);
  padding-left: 8px;
  padding-right: 8px;
  box-sizing: border-box;
}
.item_left{
    flex:1;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.item_center{
    flex:2;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.item_right{
    flex:1;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.item_bottom{
  padding-left: 6px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    line-height: 32px;
    display: flex;
    flex-direction: row;
    height: 32px;
    justify-content: space-between;
    /* padding-right: 8px; */
    align-items: center;
}
.item_left_money{
  width: 100%;
  text-align: center;
  height: 36px;
  line-height: 36px;
}
.item_content{
  height: 100px;
  border-bottom:1px dashed #e7e7e7;
  display: flex;
  flex-direction: row;
}
.font{
  font-size: 28px;
  color: #B3212D;
}
.font1{
  font-size: 12px;
  color: #B3212D;
}
.font3{
  font-size: 16px;
  font-weight: bold;
  color:  rgb(34,34,34);
}
.btn{
  width: 70px;
  height: 30px;
  line-height: 30px;
  color: #B3212D;
  border: 1px solid #B3212D;
  border-radius: 30px;
  color: 16px;
  text-align: center;
  font-weight: bold;
  font-size: 12px;
  margin-right: 5px;
}
.right_icon{
  width: 8px;
  height: 15px;
}

</style>

<script>
import { getmycoupons } from '../apollo/apollo'
export default {
  components: {
    
  },
  data() {
    return {
      rightImg:'./static/imgs/right.png',
      emptyImg:'./static/imgs/empty@2x.png',
      tab:true,
      getmycoupons:getmycoupons,
      getCoupon:[],
      kcList:[],//课程List
      ghList:[],//课程List
    }
  },
  computed:{
    
  },
  created() {
    this.initDate()
  },
  mounted(){
 
  },
  methods: {
    chose(item,i){
      if(i==0){
        this.tab=true;
        this.getCoupon=this.kcList
      }else{
        this.tab=false;
        this.getCoupon=this.ghList
      }
    },

    initDate(){
      getmycoupons().then(res=>{
        document.title=this.$store.state.title;
        // this.getCoupon=res.data.getCoupon;
        res.data.getCoupon.map((ele,idx)=>{
          if(ele.type!='3'){
            this.kcList.push(ele)
          }
          if(ele.type!='2'){
            this.ghList.push(ele)
          }
        })
        this.getCoupon=this.kcList


        })
        .catch(err=>{
          this.msgManage(err)
        })
    },

    toUse(index){
      if(index==2){
        this.jump('./course')
      }else{
        this.jump('./index')
      }
    }

  }, 
  destroyed () {  
      
    
  },
  watch:{
    
  }
};
</script>


// WEBPACK FOOTER //
// src/views/mycoupons.vue